<script lang="ts">
  import { afterUpdate, createEventDispatcher } from 'svelte';
  import type { ImgComponentProps } from '../helpers';
  import { is } from '@shared/lib/utils';

  const ELEMENT_WIDTH = 300; // dom element width in px. Must be LESS than VIEWPORT width, but the BIGGER the more ACCURATE final position will be

  export let src: string;
  export let isShown = false;
  export let isAnimated: boolean;
  export let animDuration: number;
  export let componentProps: ImgComponentProps;

  let scale: number;
  let ratio: number;
  let translateX: number;
  let translateY: number;

  let imgDOMElement: HTMLImageElement;

  //count transform values to render element in desired position with desired size
  $: scale = componentProps.w / ELEMENT_WIDTH;
  $: ratio = componentProps.w / componentProps.h || 1;
  $: translateX = componentProps.x - ELEMENT_WIDTH / 2 + (ELEMENT_WIDTH * scale) / 2;
  $: translateY = componentProps.y - ELEMENT_WIDTH / 2 / ratio + (ELEMENT_WIDTH * scale) / 2 / ratio;

  const dispatch = createEventDispatcher();

  afterUpdate(() => {
    if (imgDOMElement) {
      // additional check in case if not bound yet
      imgDOMElement.onload = () => {
        dispatch('onload'); // call on:onload function when image is loaded (its not immediately and can be visible)
      };
    }
  });
</script>

<img
  bind:this="{imgDOMElement}"
  {src}
  class="absolute left-0 top-0 {is(isShown, 'opacity-100', 'opacity-0')}"
  style="
        transition: {isAnimated ? `opacity ${animDuration}ms, transform ${animDuration}ms` : 'none'};
        width: {ELEMENT_WIDTH}px;
        transform: translate({translateX}px, {translateY}px) scale({scale});"
  alt="artwork"
/>
